import React from "react";
import Card from "./Card";
import colors from "../theme/colors";
import typography from "../theme/typography";

export default function SummaryMetricCard({
  children,
  title,
  value,
  subtitle,
  size = "md",
  variant = "default",
  disabled = false,
  softSurface = false,
  style = {},
  className = "",
}) {
  const sizeMap = {
    compact: {
      padding: 9,
      titleSize: "11px",
      valueSize: typography.size.base,
      subtitleSize: typography.size.xs,
      gap: 3,
      minHeight: 60,
    },
    sm: {
      padding: 11,
      titleSize: "11px",
      valueSize: typography.size.base,
      subtitleSize: typography.size.xs,
      gap: 4,
      minHeight: 70,
    },
    md: {
      padding: 13,
      titleSize: typography.size.xs,
      valueSize: typography.size.xl,
      subtitleSize: typography.size.xs,
      gap: 5,
      minHeight: 92,
    },
    lg: {
      padding: 16,
      titleSize: typography.size.sm,
      valueSize: typography.size["2xl"] || typography.size.xl,
      subtitleSize: typography.size.sm,
      gap: 8,
      minHeight: 112,
    },
  };

  const variantMap = {
    default: {
      titleColor: colors.textSecondary,
      valueColor: colors.textPrimary,
      subtitleColor: colors.textSecondary,
    },
    soft: {
      titleColor: colors.textSecondary,
      valueColor: colors.primaryDark || colors.primary,
      subtitleColor: colors.textSecondary,
    },
  };

  const resolvedSize = sizeMap[size] || sizeMap.md;
  const resolvedVariant = variantMap[variant] || variantMap.default;

  const cardStyle = {
    padding: resolvedSize.padding,
    minHeight: resolvedSize.minHeight,
    opacity: disabled ? 0.6 : 1,
    background: softSurface ? (colors.surfaceSoft || "#FBF9FE") : colors.surface,
    border: `1px solid ${softSurface ? (colors.borderSoft || colors.border) : colors.border}`,
    boxShadow: softSurface ? "0 1px 2px rgba(31, 23, 50, 0.04)" : undefined,
    ...style,
  };

  return (
    <Card className={className} style={cardStyle}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: resolvedSize.gap,
          width: "100%",
          height: "100%",
        }}
      >
        {title ? (
          <div
            style={{
              fontFamily: typography.fontFamily,
              fontSize: resolvedSize.titleSize,
              lineHeight: typography.lineHeight.sm,
              fontWeight: typography.weight.semibold,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: resolvedVariant.titleColor,
            }}
          >
            {title}
          </div>
        ) : null}

        <div
          role="text"
          style={{
            fontFamily: typography.fontFamily,
            fontSize: resolvedSize.valueSize,
            lineHeight: typography.lineHeight.tight,
            fontWeight: typography.weight.bold,
            color: resolvedVariant.valueColor,
            wordBreak: "break-word",
          }}
        >
          {value}
        </div>

        {(subtitle || children) ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 4,
            }}
          >
            {subtitle ? (
              <div
                style={{
                  fontFamily: typography.fontFamily,
                  fontSize: resolvedSize.subtitleSize,
                  lineHeight: typography.lineHeight.sm,
                  fontWeight: typography.weight.regular,
                  color: resolvedVariant.subtitleColor,
                }}
              >
                {subtitle}
              </div>
            ) : null}

            {children ? <div>{children}</div> : null}
          </div>
        ) : null}
      </div>
    </Card>
  );
}